import Vue from 'vue'
import Vuex from 'vuex';
import { attestations } from '@store/modules/attestations';
import { groupSelector } from '@store/modules/groupSelector';
import { auth } from '@store/modules/auth'
import { notifications } from '@store/modules/notifications'
import { portalContext } from '@store/modules/portalContext'
import { memberManagement } from '@store/modules/memberManagement'
import { billing } from '@store/modules/billing'
import { reporting } from '@store/modules/reporting'
import { getField, updateField } from 'vuex-map-fields'
import { addFamily } from '@store/modules/addFamily'
import { queryStringHelper } from '@store/modules/queryStringHelper'
import { users } from '@store/modules/users'
import { users2 } from '@store/modules/users2';
import { providerLocator } from '@store/modules/providerLocator'
import { cacheBuster } from '@store/modules/cacheBuster'
import { selectOptionsFromApi } from '@store/modules/selectOptionsFromApi'
import { userManagement } from '@store/modules/userManagement'
import { contacts } from '@store/modules/contacts'
import cloudCannon from '@store/modules/cloudCannon'
import { openEnrollment } from '@store/modules/open-enrollment'
import { clientOnboardingManagement } from '@store/modules/clientOnboardingManagement'
import { universalSearch } from '@store/modules/universalSearch';
import { hiddenRouteData } from '@store/modules/hiddenRouteData';
import VuexPersistence from 'vuex-persist'
import localForage from 'localforage'

const vuexLocal = new VuexPersistence({
  reducer: state => ({
    addFamily: state.addFamily,
    portalContext: state.portalContext,
    auth: state.auth,
    billing: state.billing,
    groupSelector: state.groupSelector,
    hiddenRouteData: state.hiddenRouteData
  }),
  storage: localForage,
  asyncStorage: true
})
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  state: {
    addLocation: false,
    editLocation: false
  },
  mutations: {
    updateField,
    TOGGLE_ADD_LOCATION(state, payload) {
      state.addLocation = payload
    },
    TOGGLE_EDIT_LOCATION(state, payload) {
      state.editLocation = payload
    }
  },
  getters: {
    getField,
    parentOrGroupCk(state) {
      // We always want to use the parentGroupCk for OE if available. If not, use the groupCk
      // If EXTERNAL User - grab parentGroupCk from sub-group or groupCk if parentGroupCk does not exist
      const subGroup = state.auth.subGroupAccess && state.auth.subGroupAccess.length > 0 ? state.auth.subGroupAccess.filter((sub) => {
        return sub.subGroupId === state.groupSelector.subGroup && state.groupSelector.subGroup.subGroupId && sub.subGroupCk === state.groupSelector.subGroup.subGroupCk
      })[0] : undefined

      if (subGroup && subGroup.parentGroupCk) return subGroup.parentGroupCk

      // If INTERNAL User - grab parentGroupCk from group search or groupCk if parentGroupCk does not exist
      else if (state.groupSelector.parentGroup && state.groupSelector.parentGroup.parentGroupCk > 0) {
        return state.groupSelector.parentGroup.parentGroupCk
      } else {
        return undefined
      }
    }
  },
  actions: {
    toggleAddLocation({ commit, state }, payload) {
      if (payload === undefined) payload = !state.addLocation
      commit('TOGGLE_ADD_LOCATION', payload)
    },
    toggleEditLocation({ commit, state }, payload) {
      if (payload === undefined) payload = !state.editLocation
      commit('TOGGLE_EDIT_LOCATION', payload)
    }
  },
  modules: {
    addFamily,
    attestations,
    auth,
    billing,
    cacheBuster,
    clientOnboardingManagement,
    cloudCannon,
    groupSelector,
    queryStringHelper,
    memberManagement,
    notifications,
    openEnrollment,
    portalContext,
    providerLocator,
    reporting,
    selectOptionsFromApi,
    universalSearch,
    userManagement,
    users,
    users2,
    contacts,
    hiddenRouteData
  }
})
